module.exports = __webpack_public_path__ + "static/img/5_1.8ab749ba.jpg";